/**
 * Exposure ids registered on the game web admin site, read through `/exposures/v1/no-auth/{id}`.
 * Case-insensitive on the API side; kept lowercase to match how they are registered.
 *
 * Deliberately a leaf module with no imports: route files tag themselves with these, and reaching
 * for the store instead would close a `routes -> store -> helpers/api -> router -> routes` cycle.
 */
export const EXPOSURE_GLOBAL_SEARCH = 'global-search'
